<div class="pageheader">
    <div class="page-title">
        <h1>Sequences</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Sequences log'">
                <app-change-log-link-entity type="Sequence"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='sequences' [bizSetColumnChooser]="true"
    [bizSetAllowColumnReordering]="false" [bizSetPager]="false" (onInitNewRow)="onInitNewRow($event)"
    (onEditingStart)="onEditingStart($event)" (onRowInserting)="onRowInserting($event)"
    (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)" [bizEditRowOnDoubleClick]="true">
    <dxo-editing mode="row" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding"
        [allowDeleting]="allowDeleting"></dxo-editing>

    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxi-column dataField="Name" caption="Name" dataType="string" width="35%" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="MinValue" caption="Min Value" dataType="number" width="10%"
        [visible]="true">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="Increment" caption="Increment" dataType="number" width="10%">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="NextValue" caption="Next Value" dataType="number" width="10%">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="IsSystemSequence" caption="Is System" dataType="boolean" width="10%"
        [allowEditing]="false" fixed="true" fixedPosition="right">
        <dxo-form-item [visible]="false"></dxo-form-item>
    </dxi-column>

    <dxi-column dataField="MaxValue" caption="Max Value" dataType="number" width="230"
        [visible]="false" [alignment]="'center'">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column type="buttons" width="200">
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
        <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
        </dxi-button>
    </dxi-column>

    <ng-container *dxTemplate="let cell of 'logTemplate'">
        <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name"
            [showIcon]="false" classNames="dx-link">
            <app-change-log-link-entity type="Sequence" [id]="cell.data.Id"></app-change-log-link-entity>
        </app-change-log-link>
    </ng-container>

</dx-data-grid>
